/**
 * MajusculeText React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core";


/**
 * component for majuscule text (starting with <xy>) or normal text
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
function MajusculeText(props) {

    const {classes, text} = props;

    if (text && text.startsWith("<") && text.indexOf(">") > 0) {
        const endIndex = text.indexOf(">");
        let majuscules = text.substring(1, endIndex);
        let rest = text.substring(endIndex + 1);
        return <div>
            <div className={classes.majuscules + " " + props.classNameMajuscules}>{majuscules}</div>
            <div className={classes.text + " " + props.classNameText}>{rest}</div>
        </div>;
    } else {
        return <div className={classes.text + " " + props.classNameText}>{text}</div>;
    }
}

MajusculeText.propTypes = {
    text: PropTypes.string,
    classNameText: PropTypes.string,
    classNameMajuscules: PropTypes.string
};

const styles = theme => ({
    text: {
        fontSize: "5.8vw",
        hyphens: "auto"
    },
    majuscules: {
        marginRight: "2vw",
        fontSize: "16vw",
        lineHeight: 1.25,
        float: "left",
        marginTop: "-3vw",
        height: "16vw"
    }
});

export default withStyles(styles)(MajusculeText);
